import { DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "src/components/core/Dialog";
import TermsComponent from "src/components/seller/Terms";

const TermDialog = ({ userData, onClose }) => {
  const handleOnClose = () => {
    onClose();
  };

  return (
    <Dialog
      onClose={handleOnClose}
      aria-labelledby="customized-dialog-title"
      open={true}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: 900,
            borderRadius: 4,
          },
        },
        "& .MuiDialogContent-root": {
          pt: 1,
          pb: 4,
          px: 4,
        },
      }}
    >
      <DialogTitle sx={{ p: 3 }}>
        <IconButton
          aria-label="close"
          onClick={handleOnClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <TermsComponent userData={userData} />
      </DialogContent>
    </Dialog>
  );
};

export default TermDialog;
